import React, { useEffect, useRef, useState } from 'react';
import {
  ScrollView,
  View,
  Text,
  TextInput,
  Pressable,
  TouchableOpacity,
  Dimensions,
  Image,
  Platform,
  ActivityIndicator,
  Linking,
  Switch,
  ViewStyle,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { Editor } from 'primereact/editor';
import { FontAwesome5 } from '@expo/vector-icons';
import { RadioButton } from 'react-native-paper';

import {
  getLanguagesData,
  getCountriesData,
  getCurrenciesData,
  getTimezonesData,
  getDateformatsData,
  getTimeformatsData,
  updateStoreDetail,
  getStoreDetail,
  getDocumentsData,
  getTaxcodesData,
  getLocationsData,
  updateStoreLocation,
  getStoreLocationsData,
  deleteStoreLocation,
  getBrandContentById,
  getDriverScreeningConfig,
  updateDriverScreeningConfig,
} from '../../../api/Settings';
import { msgStr } from '../../../common/constants/Message';
import { API_URL } from '../../../common/constants/AppConstants';
import { TextMediumLargeSize, TextdefaultSize } from '../../../common/constants/Fonts';
import { BOHTlbCheckbox } from '../../../common/components/bohtoolbar';
import { useAlertModal } from '../../../common/hooks';
import BasicLayout from '../../../common/components/CustomLayout/BasicLayout';
import DriverScreeningInfoModal from './DriverScreeningInfoModal';

import { StoreDetailsStyle } from './styles/StoreDetailsStyle';
import NumericInput from '../../../common/components/formcomponents/NumericInput';
import WebView from 'react-native-webview';
import LocationChips from './LocationChips';
import BrandContent from './brandContent';
import Select from '../../../common/components/ui/Select';
import LabeledTextInput from '../../../common/components/bohform/LabeledTextInput';

const StoreDetails = ({ navigation, brandId, brandName, openStoreDetail }) => {
  const { showAlert } = useAlertModal();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isSouthBeach = hostname === 'southbeach.bodhisys.io';


  const [isLoading, setIsLoading] = useState(false);

  const inputRef = useRef(null);
  const defaultInputRef = useRef(null);

  const [Languages, setLanguages] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [Timezones, setTimezones] = useState([]);
  const [Currencies, setCurrencies] = useState([]);
  const [Dateformats, setDateformats] = useState([]);
  const [Timeformats, setTimeformats] = useState([]);
  const [Documents, setDocuments] = useState([]);

  const [weekdays, setWeekdays] = useState([
    { id: 7, weekday: 'Sunday' },
    { id: 1, weekday: 'Monday' },
    { id: 2, weekday: 'Tuesday' },
    { id: 3, weekday: 'Wednesday' },
    { id: 4, weekday: 'Thursday' },
    { id: 5, weekday: 'Friday' },
    { id: 6, weekday: 'Saturday' },
  ]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [Language, setLanguage] = useState(0);
  const [storeNameTxt, setStoreNameTxt] = useState('');
  const [storeURLTxt, setStoreURLTxt] = useState('');
  const [AddressLine1Txt, setAddressLine1Txt] = useState('');
  const [AddressLine2Txt, setAddressLine2Txt] = useState('');
  const [CityTxt, setCityTxt] = useState('');
  const [StateTxt, setStateTxt] = useState('');
  const [PostalCodeTxt, setPostalCodeTxt] = useState('');
  const [ShopLatitudeTxt, setShopLatitudeTxt] = useState(0);
  const [ShopLongitudeTxt, setShopLongitudeTxt] = useState(0);
  const [phoneNumberTxt, setPhoneNumberTxt] = useState('');
  const [blockoutDay, setBlockoutDay] = useState('');
  const [SalesTaxTxt, setSalesTaxTxt] = useState(0);

  const [PrimaryLanguage, setPrimaryLanguage] = useState(0);
  const [Country, setCountry] = useState(0);
  const [Timezone, setTimezone] = useState(0);
  const [Currency, setCurrency] = useState(0);
  const [Dateformat, setDateformat] = useState(0);
  const [Timeformat, setTimeformat] = useState(0);
  const [PickupTime, setPickupTime] = useState('');
  const [CutOffTime, setCutOffTime] = useState('');
  const [DropOffTime, setDropOffTime] = useState('');
  const [WeekStart, setWeekStart] = useState(0);
  const [Locations, setLocations] = useState([]);

  const [StoreWavier, setStoreWavier] = useState('');
  const [Disclaimer, setDisclaimer] = useState('');
  const [EmailConfirmation, setEmailConfirmation] = useState('');
  const [AEmailConfirmation, setAEmailConfirmation] = useState('');
  const [SwapEquipmentConfirmation, setSwapEquipmentConfirmation] = useState('');
  const [TextConfirmation, setTextConfirmation] = useState('');
  const [DocumentRequestEmail, setDocumentRequestEmail] = useState('');
  const [DocumentRequestText, setDocumentRequestText] = useState('');
  const [documentId, setDocumentId] = useState(0);
  const [isDocument, setIsDocument] = useState(0);
  const [isDriverScreeningRequired, setIsDriverScreeningRequired] = useState(0);
  const [isLicenseRequired, setIsLicenseRequired] = useState(0);
  const [isInsuranceRequired, setIsInsuranceRequired] = useState(0);
  const [isAgreementRequired, setIsAgreementRequired] = useState(0);
  const [isLockCombinationRequired, setIsLockCombinationRequired] = useState(0);
  const [isDriveOffLocation, setIsDriveOffLocation] = useState(0);
  const [isBodhiProtectEnabled, setIsBodhiProtectEnabled] = useState(0);
  const [isConfirmationEmailEnabled, setIsConfirmationEmailEnabled] = useState(0);
  const [bodhiProtectDefault, setBodhiProtectDefault] = useState(0);
  const [bodhiProtectPercentage, setBodhiProtectPercentage] = useState('0.00');
  const [isServiceFeeEnabled, setIsServiceFeeEnabled] = useState(0);
  const [serviceFeePercentage, setServiceFeePercentage] = useState('0.00');
  const [selectedDocument, setSelectedDocument] = useState<any>({});
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [brandContentFields, setBrandContentFields] = useState([]);
  const [selectedStoreLocation, setSelectedStoreLocation] = useState('');
  const [storeBelongTo, setStoreBelongTo] = useState('');
  const [isRental, setIsRental] = useState(0);
  const [allowPartialDayRentals, setAllowPartialDayRentals] = useState(0);
  const [bacLimit, setBacLimit] = useState('0.00');
  const [requireUspsAddress, setRequireUspsAddress] = useState(0);
  const [uspsZipCodes, setUspsZipCodes] = useState('');

  const [taxCodes, setTaxCodes] = useState([]);
  const [selectedTaxCode, selectTaxCode] = useState("");
  const [selectedProcessMode, selectProcessMode] = useState(0);
  const [showDriverScreeningInfo, setShowDriverScreeningInfo] = useState(false);
  const [driverScreeningConfig, setDriverScreeningConfig] = useState<any>({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    await getLanguagesData((jsonRes, status, error) => {
      if (status == 200) {
        setLanguages(jsonRes);
        if (jsonRes[0]) {
          setLanguage(jsonRes[0].id);
        } else setLanguage(0);
      }
    });
    await getCountriesData((jsonRes, status, error) => {
      if (status == 200) {
        setCountries(jsonRes);
        if (jsonRes[0]) {
          setCountry(jsonRes[0].id);
        } else setCountry(0);
      }
    });
    await getTimezonesData((jsonRes, status, error) => {
      if (status == 200) {
        setTimezones(jsonRes);
        if (jsonRes[0]) {
          setTimezone(jsonRes[0].id);
        } else setTimezone(0);
      }
    });
    await getCurrenciesData((jsonRes, status, error) => {
      if (status == 200) {
        setCurrencies(jsonRes);
        if (jsonRes[0]) {
          setCurrency(jsonRes[0].id);
        } else setCurrency(0);
      }
    });
    await getDateformatsData((jsonRes, status, error) => {
      if (status == 200) {
        setDateformats(jsonRes);
        if (jsonRes[0]) {
          setDateformat(jsonRes[0].id);
        } else setDateformat(0);
      }
    });
    await getTimeformatsData((jsonRes, status, error) => {
      if (status == 200) {
        setTimeformats(jsonRes);
        if (jsonRes[0]) {
          setTimeformat(jsonRes[0].id);
        } else setTimeformat(0);
      }
    });
    await getDocumentsData((jsonRes, status, error) => {
      if (status == 200) {
        setDocuments(jsonRes);
        if (jsonRes[0]) {
          setDocumentId(jsonRes[0].id);
        } else setDocumentId(0);
      }
    });
    await getTaxcodesData((jsonRes, status, error) => {
      if (status == 200) {
        setTaxCodes(jsonRes);
        if (jsonRes[0]) {
          selectTaxCode(jsonRes[0].id);
        } else selectTaxCode(null);
      } else setTaxCodes([]);
    });
    await getStoreDetail(brandId, (jsonRes, status, error) => {
      if (status == 200 && jsonRes) {
        if (jsonRes.store_name) setStoreNameTxt(jsonRes.store_name);
        if (jsonRes.store_url) setStoreURLTxt(jsonRes.store_url);
        if (jsonRes.language_id) setLanguage(jsonRes.language_id);
        if (jsonRes.logo_url) setImagePreviewUrl(API_URL + jsonRes.logo_url);
        if (jsonRes.address_line1) setAddressLine1Txt(jsonRes.address_line1);
        if (jsonRes.address_line2) setAddressLine2Txt(jsonRes.address_line2);
        if (jsonRes.city) setCityTxt(jsonRes.city);
        if (jsonRes.state) setStateTxt(jsonRes.state);
        if (jsonRes.postal_code) setPostalCodeTxt(jsonRes.postal_code);
        if (jsonRes.latitude) setShopLatitudeTxt(jsonRes.latitude);
        if (jsonRes.longitude) setShopLongitudeTxt(jsonRes.longitude);
        if (jsonRes.phone_number) setPhoneNumberTxt(jsonRes.phone_number);
        if (jsonRes.blockout_day) setBlockoutDay(jsonRes.blockout_day);
        if (jsonRes.country_id) setCountry(jsonRes.country_id);
        if (jsonRes.primary_language_id) setPrimaryLanguage(jsonRes.primary_language_id);
        if (jsonRes.timezone_id) setTimezone(jsonRes.timezone_id);
        if (jsonRes.currency_id) setCurrency(jsonRes.currency_id);
        if (jsonRes.date_format) setDateformat(jsonRes.date_format);
        if (jsonRes.time_format) setTimeformat(jsonRes.time_format);
        if (jsonRes.week_start_day) setWeekStart(jsonRes.week_start_day);
        if (jsonRes.sales_tax) setSalesTaxTxt(jsonRes.sales_tax);
        if (jsonRes.store_wavier) setStoreWavier(jsonRes.store_wavier);
        if (jsonRes.disclaimer) setDisclaimer(jsonRes.disclaimer);
        if (jsonRes.email_confirmation) setEmailConfirmation(jsonRes.email_confirmation);
        if (jsonRes.abandoned_email_confirmation) setAEmailConfirmation(jsonRes.abandoned_email_confirmation);
        if (jsonRes.swap_equipment_confirmation) setSwapEquipmentConfirmation(jsonRes.swap_equipment_confirmation);
        if (jsonRes.text_confirmation) setTextConfirmation(jsonRes.text_confirmation);
        if (jsonRes.document_request_email) setDocumentRequestEmail(jsonRes.document_request_email);
        if (jsonRes.document_request_text) setDocumentRequestText(jsonRes.document_request_text);
        if (jsonRes.document_id) setDocumentId(jsonRes.document_id);
        if (jsonRes.is_document) setIsDocument(jsonRes.is_document);
        if (jsonRes.is_license_required) setIsLicenseRequired(jsonRes.is_license_required);
        if (jsonRes.is_insurance_required) setIsInsuranceRequired(jsonRes.is_insurance_required);
        if (jsonRes.is_agreement_required) setIsAgreementRequired(jsonRes.is_agreement_required);
        if (jsonRes.is_combination_required) setIsLockCombinationRequired(jsonRes.is_combination_required);
        if (jsonRes.is_bodhi_protect_enabled) setIsBodhiProtectEnabled(jsonRes.is_bodhi_protect_enabled);
        if (jsonRes.is_confirmation_email_enabled) setIsConfirmationEmailEnabled(jsonRes.is_confirmation_email_enabled);
        if (jsonRes.bodhi_protect_default) setBodhiProtectDefault(jsonRes.bodhi_protect_default);
        if (jsonRes.bodhi_protect_percentage) setBodhiProtectPercentage(jsonRes.bodhi_protect_percentage);
        if (jsonRes.is_service_fee_enabled) setIsServiceFeeEnabled(jsonRes.is_service_fee_enabled);
        if (jsonRes.service_fee_percentage) setServiceFeePercentage(jsonRes.service_fee_percentage);
        if (jsonRes.is_driveoff_location) setIsDriveOffLocation(jsonRes.is_driveoff_location);
        if (jsonRes.store_belong_to) setStoreBelongTo(jsonRes.store_belong_to);
        if (jsonRes.taxcode_id) selectTaxCode(jsonRes.taxcode_id);
        if (jsonRes.pickup_time) setPickupTime(jsonRes.pickup_time);
        if (jsonRes.cut_off_time) setCutOffTime(jsonRes.cut_off_time);
        if (jsonRes.dropoff_time) setDropOffTime(jsonRes.dropoff_time);
        if (jsonRes.process_mode) selectProcessMode(jsonRes.process_mode);
        if (jsonRes.is_rental) setIsRental(jsonRes.is_rental);
        if (jsonRes.allow_partial_day_rentals) setAllowPartialDayRentals(jsonRes.allow_partial_day_rentals);
        if (jsonRes.bac_limit) setBacLimit(jsonRes.bac_limit);
        if (jsonRes.require_usps_address) setRequireUspsAddress(jsonRes.require_usps_address);
        if (jsonRes.usps_zip_codes) setUspsZipCodes(jsonRes.usps_zip_codes);
      }
    });
    await getLocationsData({}, (jsonRes, status, error) => {
      if (status == 200) {
        setLocations(jsonRes);
      } else {
        setLocations([]);
      }
    });
    await getStoreLocationsData(brandId, (jsonRes, status, error) => {
      if (status == 200) {
        setSelectedLocation(jsonRes.storeLocations);
      } else {
        setSelectedLocation([]);
      }
    });
    await getBrandContentById(brandId, (jsonRes, status) => {
      if (status === 200) {
        setBrandContentFields(jsonRes || []);
      } else {
        setBrandContentFields([]);
      }
    });
  };

  const fetchDriverScreeningConfig = async () => {
    await getDriverScreeningConfig({ brand_id: brandId }, (jsonRes, status, error) => {
      if (status === 200 && jsonRes) {
        const data = typeof jsonRes.questions === 'string' ? JSON.parse(jsonRes.questions) : jsonRes.questions || {};
        setDriverScreeningConfig(data);
      }
    });
  };

  const handleSaveDriverScreening = async (config) => {
    await updateDriverScreeningConfig({ brand_id: brandId, questions: config }, (jsonRes, status, error) => {
      if (status === 200) {
        // setDriverScreeningConfig(config);
        setShowDriverScreeningInfo(false);
        showAlert('success', "Questionnaire saved.");
      }
    });
  };

  useEffect(() => {
    if (showDriverScreeningInfo) {
      fetchDriverScreeningConfig();
    }
  }, [showDriverScreeningInfo]);

  const cardStyle: ViewStyle = {
    width: '60%' as unknown as ViewStyle['width'],
    minWidth: 500,
    marginVertical: 30,
    padding: 36,
    backgroundColor: 'white',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#b3b3b3',
    shadowColor: '#999',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 8,
  };

  useEffect(() => {
    if (Documents.length > 0) {
      const result = Documents.find((document) => document.id === documentId);
      if (result) {
        setSelectedDocument(result);
      }
    }
  }, [documentId]);

  const handleImageSelection = (event) => {
    const file = Platform.OS == 'web' ? event.target.files[0] : event.nativeEvent.target.files[0];

    const imagePreviewUrl = URL.createObjectURL(file);
    setSelectedImage(file);
    setImagePreviewUrl(imagePreviewUrl);
  };

  const SaveForm = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('brand_id', brandId);
    formData.append('store_name', storeNameTxt);
    formData.append('store_url', storeURLTxt);
    formData.append('language_id', Language.toString());
    if (selectedImage) formData.append('img', selectedImage);
    formData.append('address_line1', AddressLine1Txt);
    formData.append('address_line2', AddressLine2Txt);
    formData.append('city', CityTxt);
    formData.append('state', StateTxt);
    formData.append('postal_code', PostalCodeTxt);
    formData.append('latitude', ShopLatitudeTxt.toString());
    formData.append('longitude', ShopLongitudeTxt.toString());
    formData.append('phone_number', phoneNumberTxt);
    formData.append('blockout_day', blockoutDay);
    formData.append('country_id', Country.toString());
    formData.append('primary_language_id', PrimaryLanguage.toString());
    formData.append('timezone_id', Timezone.toString());
    formData.append('currency_id', Currency.toString());
    formData.append('date_format', Dateformat.toString());
    formData.append('time_format', Timeformat.toString());
    formData.append('week_start_day', WeekStart.toString());
    formData.append('cut_off_time', CutOffTime.toString());
    // formData.append('sales_tax', SalesTaxTxt.toString());
    formData.append('store_wavier', StoreWavier);
    formData.append('disclaimer', Disclaimer);
    formData.append('document_id', documentId.toString());
    formData.append('is_document', isDocument.toString());
    formData.append('is_license_required', isLicenseRequired.toString());
    formData.append('is_insurance_required', isInsuranceRequired.toString());
    formData.append('is_agreement_required', isAgreementRequired.toString());
    formData.append('is_combination_required', isLockCombinationRequired.toString());
    formData.append('is_driveoff_location', isDriveOffLocation.toString());
    formData.append('is_rental', isRental.toString());
    formData.append('allow_partial_day_rentals', allowPartialDayRentals.toString());
    formData.append('store_belong_to', storeBelongTo);
    // BodhiProtect & Service Fee settings are controlled exclusively by the
    // platform administrator via the LLC master Brand Pricing modal — the tenant
    // no longer submits these fields.
    // formData.append('is_bodhi_protect_enabled', isBodhiProtectEnabled.toString());
    formData.append('is_confirmation_email_enabled', isConfirmationEmailEnabled.toString());
    // formData.append('bodhi_protect_default', bodhiProtectDefault.toString());
    // formData.append('bodhi_protect_percentage', bodhiProtectPercentage.toString());
    // formData.append('is_service_fee_enabled', isServiceFeeEnabled.toString());
    // formData.append('service_fee_percentage', serviceFeePercentage.toString());
    formData.append('taxcode_id', selectedTaxCode.toString());
    formData.append('pickup_time', PickupTime.toString());
    formData.append('dropoff_time', DropOffTime.toString());
    formData.append('email_confirmation', EmailConfirmation);
    formData.append('abandoned_email_confirmation', AEmailConfirmation);
    formData.append('swap_equipment_confirmation', SwapEquipmentConfirmation);
    formData.append('text_confirmation', TextConfirmation);
    formData.append('document_request_email', DocumentRequestEmail);
    formData.append('document_request_text', DocumentRequestText);
    formData.append('process_mode', selectedProcessMode.toString());
    formData.append('bac_limit', bacLimit.toString());
    formData.append('require_usps_address', requireUspsAddress.toString());
    formData.append('usps_zip_codes', uspsZipCodes);

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 200:
        case 201:
          showAlert('success', jsonRes.message);
          break;
        case 409:
          // setValidMessage(jsonRes.error);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
      setIsLoading(false);
    };

    updateStoreDetail(formData, (jsonRes, status) => {
      handleResponse(jsonRes, status);
    });
  };

  const openStoreLink = () => {
    if (storeURLTxt && storeURLTxt.trim()) {
      const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
      const isRentalHost = hostname === 'vehicle.bodhisys.io' || hostname === 'localhost' || hostname === '127.0.0.1';
      let baseUrl = storeURLTxt.toLowerCase();
      if (!baseUrl.startsWith('http://') && !baseUrl.startsWith('https://')) {
        baseUrl = 'https://' + baseUrl;
      }
      const urlToOpen = isRentalHost ? baseUrl + '/rental' : baseUrl;
      Linking.openURL(urlToOpen);
    }
  };

  const handleAddLocation = (locationId) => {
    if (!locationId) {
      // showAlert('error', 'Location ID is required');
      return;
    }

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 200:
        case 201:
          showAlert('success', jsonRes.message);
          // Temp
          setTimeout(() => {
            setSelectedStoreLocation('')
            getStoreLocationsData(brandId, (jsonRes, status, error) => {
              if (status == 200) {
                setSelectedLocation(jsonRes.storeLocations);
              } else {
                setSelectedLocation([]);
              }
            });
          }, 1000);

          break;
        case 409:
          showAlert('error', jsonRes.error);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
      // setIsLoading(false);
    };

    const payload = {
      brand_id: brandId,
      location_id: parseInt(locationId),
      is_default: false,
    };

    updateStoreLocation(payload, (jsonRes, status) => {
      handleResponse(jsonRes, status);
    });
  };

  const handleDeleteLocation = (locationId) => {
    deleteStoreLocation(locationId, (jsonRes, status, error) => {
      if (status === 200) {
        showAlert('success', 'Location deleted successfully');
        // Refresh locations list
        getLocationsData({}, (jsonRes, status, error) => {
          if (status === 200) {
            setLocations(jsonRes);

            // Temp
            setTimeout(() => {
              getStoreLocationsData(brandId, (jsonRes, status, error) => {
                if (status == 200) {
                  setSelectedLocation(jsonRes.storeLocations);
                } else {
                  setSelectedLocation([]);
                }
              });
            }, 1000);
          }
        });
      } else {
        showAlert('error', error || 'Failed to delete location');
      }
    });
  };

  const quillModules = {
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        openStoreDetail(null);
      }}
      screenName={brandName}
    >
      {Platform.OS === 'web' && (
        <style>
          {`
            .p-editor-container .ql-editor h1, 
            .p-editor-container .ql-editor h2, 
            .p-editor-container .ql-editor h3, 
            .p-editor-container .ql-editor h4, 
            .p-editor-container .ql-editor h5, 
            .p-editor-container .ql-editor h6 {
              margin: 0 !important;
              padding: 0 !important;
              line-height: normal !important;
            }
          `}
        </style>
      )}
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}

      <ScrollView contentContainerStyle={{ alignItems: 'center' }}>
        <View style={cardStyle}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={{ fontSize: TextMediumLargeSize, fontWeight: 'bold' }}>Store Details</Text>
          </View>
          <Text style={styles.label}>Language</Text>
          <Picker style={styles.select} selectedValue={Language} onValueChange={setLanguage}>
            {Languages.length > 0 &&
              Languages.map((language, index) => {
                return (
                  <Picker.Item
                    style={styles.selectOption}
                    key={index}
                    label={language.language}
                    value={language.id}
                  />
                );
              })}
          </Picker>
          <Text style={styles.label}>Store Name</Text>
          <TextInput
            style={styles.input}
            placeholder="Shop Name"
            value={storeNameTxt}
            onChangeText={setStoreNameTxt}
            placeholderTextColor="#ccc"
            ref={defaultInputRef}
          />
          <View>
            <Text style={styles.label}>Store URL</Text>
            <TextInput
              style={styles.input}
              placeholder="Shop URL"
              value={storeURLTxt}
              onChangeText={setStoreURLTxt}
              placeholderTextColor="#ccc"
              ref={defaultInputRef}
            />
            <TouchableOpacity
              style={{ position: 'absolute', top: '47%', right: 10 }}
              onPress={openStoreLink}
            >
              <FontAwesome5 name="link" size={TextdefaultSize} color="#000" />
            </TouchableOpacity>
          </View>

          {Platform.OS == 'web' && (
            <>
              <Text style={styles.label}>Store Logo</Text>
              <View style={styles.imagePicker}>
                <TouchableOpacity
                  style={styles.imageUpload}
                  onPress={() => inputRef.current.click()}
                >
                  {imagePreviewUrl ? (
                    <Image source={{ uri: imagePreviewUrl }} style={styles.previewImage} />
                  ) : (
                    <View>
                      <Text style={styles.boxText}>Click to choose an image</Text>
                    </View>
                  )}
                </TouchableOpacity>
                <input
                  type="file"
                  ref={inputRef}
                  style={styles.fileInput}
                  onChange={handleImageSelection}
                />
              </View>
            </>
          )}

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Store Location</Text>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Address line 1</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Address line 1"
                  value={AddressLine1Txt}
                  onChangeText={setAddressLine1Txt}
                  placeholderTextColor="#ccc"
                />
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Address line 2</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Address line 2"
                  value={AddressLine2Txt}
                  onChangeText={setAddressLine2Txt}
                  placeholderTextColor="#ccc"
                />
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>City</Text>
                <TextInput
                  style={styles.input}
                  placeholder="City"
                  value={CityTxt}
                  onChangeText={setCityTxt}
                  placeholderTextColor="#ccc"
                />
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>State</Text>
                <TextInput
                  style={styles.input}
                  placeholder="State"
                  value={StateTxt}
                  onChangeText={setStateTxt}
                  placeholderTextColor="#ccc"
                />
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Postal code</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Postal code"
                  value={PostalCodeTxt}
                  onChangeText={setPostalCodeTxt}
                  placeholderTextColor="#ccc"
                />
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}></View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Shop latitude</Text>
                <NumericInput
                  placeholder="Shop latitude"
                  value={ShopLatitudeTxt}
                  onChangeText={setShopLatitudeTxt}
                  validMinNumber={-180}
                  validMaxNumber={180}
                />
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Shop longitude</Text>
                <NumericInput
                  placeholder="Shop longitude"
                  value={ShopLongitudeTxt}
                  onChangeText={setShopLongitudeTxt}
                  validMinNumber={-180}
                  validMaxNumber={180}
                />
              </View>
            </View>
            {/* <View style={[styles.inputRow, { marginBottom: 10 }]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Drive off location'}
                  CheckboxProps={{ value: !!isDriveOffLocation }}
                  onPress={() => setIsDriveOffLocation(+!isDriveOffLocation)}
                />
              </View>
            </View> */}
            <View style={[styles.inputRow, { marginBottom: 10 }]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Is vehicle rental'}
                  CheckboxProps={{ value: !!isRental }}
                  onPress={() => setIsRental(+!isRental)}
                />
              </View>
            </View>
            {/* {!!isRental && (
              <View style={styles.inputRow}>
                <View style={[styles.inputContainer, { flex: 1 }]}>
                  <Text style={[styles.label, { marginBottom: 8 }]}>Store Belong To</Text>
                  <View style={{ paddingLeft: 3 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                      <RadioButton
                        value={'charleston'}
                        status={storeBelongTo === 'charleston' ? 'checked' : 'unchecked'}
                        onPress={() => setStoreBelongTo('charleston')}
                      />
                      <Text>{'Charleston'}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                      <RadioButton
                        value={'hiltonhead'}
                        status={storeBelongTo === 'hiltonhead' ? 'checked' : 'unchecked'}
                        onPress={() => setStoreBelongTo('hiltonhead')}
                      />
                      <Text>{'Hilton Head'}</Text>
                    </View>
                  </View>
                </View>
              </View>
            )} */}
          </View>

          {/* <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Store Inventory Locations</Text>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Picker
                  style={styles.select}
                  selectedValue={selectedStoreLocation}
                  onValueChange={(itemValue) => handleAddLocation(itemValue)}
                >
                  <Picker.Item style={styles.selectOption} label="Select a location" value={null} />
                  {Locations && Locations.length > 0 &&
                    Locations.map((location, index) => (
                      <Picker.Item
                        style={styles.selectOption}
                        key={index}
                        label={location.location}
                        value={location.id}
                      />
                    ))}
                </Picker>
              </View>
            </View>

            <View>
              <LocationChips
                locations={selectedLocation || []}
                onDelete={handleDeleteLocation}
              />
            </View>
          </View> */}

          <View style={styles.inputRow}>
            <View style={[{ marginRight: 20, flex: 1 }]}>
              <Text style={styles.label}>Brand contact number</Text>
              <TextInput
                style={styles.input}
                placeholder="Brand contact number"
                value={phoneNumberTxt}
                onChangeText={setPhoneNumberTxt}
                placeholderTextColor="#ccc"
              />
            </View>
            <View style={[{ marginRight: 20, flex: 1 }]}>
              <Text style={styles.label}>Blockout day</Text>
              <TextInput
                style={styles.input}
                placeholder="Blockout day"
                value={blockoutDay}
                onChangeText={setBlockoutDay}
                placeholderTextColor="#ccc"
              />
            </View>
            <View style={[{ flex: 1 }]}>
              <Text style={styles.label}>Process Mode</Text>
              <Picker style={styles.select} selectedValue={selectedProcessMode} onValueChange={selectProcessMode}>
                <Picker.Item
                  style={styles.selectOption}
                  label={'Login first'}
                  value={0}
                />
                <Picker.Item
                  style={styles.selectOption}
                  label={'Order first'}
                  value={1}
                />
              </Picker>
            </View>
          </View>

          {/*
            BodhiProtect & Service Fee are now controlled exclusively by the
            platform administrator via the LLC master "Brand Pricing" modal.
            These sections (enable toggles, opt-in/out default, and % charges)
            are intentionally hidden from the tenant brand settings.

          {!isSouthBeach && (
            <View style={styles.inputGroup}>
              <Text style={[styles.label, styles.inputGroupLabel]}>Bodhi Protect</Text>
              <View style={[styles.inputRow, { marginBottom: 10 }]}>
                <View style={[styles.inputContainer, { flex: 1 }]}>
                  <BOHTlbCheckbox
                    style={{ marginLeft: 0 }}
                    label={'Enable Bodhi Protect'}
                    CheckboxProps={{ value: !!isBodhiProtectEnabled }}
                    onPress={() => setIsBodhiProtectEnabled(+!isBodhiProtectEnabled)}
                  />
                </View>
              </View>
              <View style={styles.inputRow}>
                <View style={[styles.inputContainer, { flex: 1 }]}>
                  <Select
                    label={"Default"}
                    options={[
                      { label: 'OPT-OUT (Default ON)', value: 1 },
                      { label: 'OPT-IN (Default OFF)', value: 0 },
                    ]}
                    value={bodhiProtectDefault}
                    onChange={(newValue) => {
                      setBodhiProtectDefault(newValue);
                    }}
                    placeholder="Select"
                  />
                </View>
              </View>
              <View style={styles.inputRow}>
                <View style={[styles.inputContainer, { flex: 1 }]}>
                  <LabeledTextInput
                    label="BodhiProtect % Charge"
                    value={bodhiProtectPercentage}
                    editable={false}
                    inputStyle={{ backgroundColor: '#f0f0f0', color: '#888' }}
                  />
                  <Text style={{ fontSize: 11, color: '#888', fontStyle: 'italic', marginTop: 4 }}>
                    Managed by the platform administrator
                  </Text>
                </View>
              </View>
            </View>
          )}


          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Service Fee</Text>
            <View style={[styles.inputRow, { marginBottom: 10 }]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Enable Service Fee'}
                  CheckboxProps={{ value: !!isServiceFeeEnabled }}
                  onPress={() => setIsServiceFeeEnabled(+!isServiceFeeEnabled)}
                />
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <LabeledTextInput
                  label="Service Fee % Charge"
                  value={serviceFeePercentage}
                  editable={false}
                  inputStyle={{ backgroundColor: '#f0f0f0', color: '#888' }}
                />
                <Text style={{ fontSize: 11, color: '#888', fontStyle: 'italic', marginTop: 4 }}>
                  Managed by the platform administrator
                </Text>
              </View>
            </View>
          </View>
          */}

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Partial Day Rentals</Text>
            <View style={[styles.inputRow, { marginBottom: 10 }]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Allow partial day rentals'}
                  CheckboxProps={{ value: !!allowPartialDayRentals }}
                  onPress={() => setAllowPartialDayRentals(+!allowPartialDayRentals)}
                />
              </View>
            </View>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                backgroundColor: '#FFF8E1',
                borderLeftWidth: 3,
                borderLeftColor: '#F5A623',
                borderRadius: 4,
                paddingVertical: 8,
                paddingHorizontal: 10,
                marginHorizontal: 8,
                marginBottom: 4,
              }}
            >
              <FontAwesome5
                name="info-circle"
                size={14}
                color="#B8860B"
                style={{ marginTop: 2, marginRight: 8 }}
              />
              <Text style={{ flex: 1, fontSize: 13, color: '#6B5300', lineHeight: 18 }}>
                <Text style={{ fontWeight: 'bold' }}>Note: </Text>
                Partial day rentals require hourly prices to be configured for your products.
              </Text>
            </View>
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Delivery Address</Text>
            <View style={[styles.inputRow, { marginBottom: 10 }]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Require verified USPS delivery address'}
                  CheckboxProps={{ value: !!requireUspsAddress }}
                  onPress={() => setRequireUspsAddress(+!requireUspsAddress)}
                />
              </View>
            </View>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                backgroundColor: '#FFF8E1',
                borderLeftWidth: 3,
                borderLeftColor: '#F5A623',
                borderRadius: 4,
                paddingVertical: 8,
                paddingHorizontal: 10,
                marginHorizontal: 8,
                marginBottom: 4,
              }}
            >
              <FontAwesome5
                name="info-circle"
                size={14}
                color="#B8860B"
                style={{ marginTop: 2, marginRight: 8 }}
              />
              <Text style={{ flex: 1, fontSize: 13, color: '#6B5300', lineHeight: 18 }}>
                <Text style={{ fontWeight: 'bold' }}>Note: </Text>
                When enabled, customers must pick a verified US address from the address
                suggestions at checkout. Manually typed, unverifiable addresses are rejected.
              </Text>
            </View>
            {!!requireUspsAddress && (
              <View style={[styles.inputRow, { marginTop: 10 }]}>
                <View style={[styles.inputContainer, { flex: 1 }]}>
                  <Text style={styles.label}>USPS Allowed Zip Codes (comma-separated)</Text>
                  <TextInput
                    style={styles.input}
                    value={uspsZipCodes}
                    onChangeText={setUspsZipCodes}
                    placeholder="e.g. 29928,29910,29926"
                  />
                </View>
              </View>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Store Locale</Text>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Country</Text>
                <Picker style={styles.select} selectedValue={Country} onValueChange={setCountry}>
                  {Countries.length > 0 &&
                    Countries.map((country, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={country.country}
                          value={country.id}
                        />
                      );
                    })}
                </Picker>
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Shop primary language</Text>
                <Picker
                  style={styles.select}
                  selectedValue={PrimaryLanguage}
                  onValueChange={setPrimaryLanguage}
                >
                  {Languages.length > 0 &&
                    Languages.map((language, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={language.language}
                          value={language.id}
                        />
                      );
                    })}
                </Picker>
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Timezone</Text>
                <Picker style={styles.select} selectedValue={Timezone} onValueChange={setTimezone}>
                  {Timezones.length > 0 &&
                    Timezones.map((timezone, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={timezone.timezone}
                          value={timezone.id}
                        />
                      );
                    })}
                </Picker>
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Currency</Text>
                <Picker style={styles.select} selectedValue={Currency} onValueChange={setCurrency}>
                  {Currencies.length > 0 &&
                    Currencies.map((currency, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={currency.currency}
                          value={currency.id}
                        />
                      );
                    })}
                </Picker>
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Date format</Text>
                <Picker
                  style={styles.select}
                  selectedValue={Dateformat}
                  onValueChange={setDateformat}
                >
                  {Dateformats.length > 0 &&
                    Dateformats.map((dateformat, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={dateformat.dateformat}
                          value={dateformat.id}
                        />
                      );
                    })}
                </Picker>
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Time format</Text>
                <Picker
                  style={styles.select}
                  selectedValue={Timeformat}
                  onValueChange={setTimeformat}
                >
                  {Timeformats.length > 0 &&
                    Timeformats.map((timeformat, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={timeformat.timeformat}
                          value={timeformat.id}
                        />
                      );
                    })}
                </Picker>
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Week start day</Text>
                <Picker
                  style={styles.select}
                  selectedValue={WeekStart}
                  onValueChange={setWeekStart}
                >
                  {weekdays.length > 0 &&
                    weekdays.map((weekday, index) => {
                      return (
                        <Picker.Item
                          style={styles.selectOption}
                          key={index}
                          label={weekday.weekday}
                          value={weekday.id}
                        />
                      );
                    })}
                </Picker>
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Cut off Time</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Cut off Time"
                  value={CutOffTime}
                  onChangeText={setCutOffTime}
                  placeholderTextColor="#ccc"
                />
              </View>
            </View>
            <View style={styles.inputRow}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>Start Time</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Start Time"
                  value={PickupTime}
                  onChangeText={setPickupTime}
                  placeholderTextColor="#ccc"
                />
              </View>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <Text style={styles.label}>End Time</Text>
                <TextInput
                  style={styles.input}
                  placeholder="End Time"
                  value={DropOffTime}
                  onChangeText={setDropOffTime}
                  placeholderTextColor="#ccc"
                />
              </View>
            </View>
          </View>
          <Text style={styles.label}>Sales tax</Text>
          <Picker style={styles.select} selectedValue={selectedTaxCode} onValueChange={selectTaxCode}>
            {taxCodes.length > 0 &&
              taxCodes.map((code, index) => {
                return (
                  <Picker.Item
                    style={styles.selectOption}
                    key={index}
                    label={code.code}
                    value={code.id}
                  />
                );
              })}
          </Picker>

          <BOHTlbCheckbox
            style={{ marginLeft: 0 }}
            label={'Require Lock Combination'}
            CheckboxProps={{ value: !!isLockCombinationRequired }}
            onPress={() => setIsLockCombinationRequired(+!isLockCombinationRequired)}
          />

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]}>
              Store Wavier
            </Text>
            <View style={{ paddingLeft: 3 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <RadioButton
                  value={'0'}
                  status={!isDocument ? 'checked' : 'unchecked'}
                  onPress={() => setIsDocument(0)}
                />
                <Text>{'Edit manually'}</Text>
              </View>
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <RadioButton
                  value={'1'}
                  status={isDocument ? 'checked' : 'unchecked'}
                  onPress={() => setIsDocument(1)}
                />
                <Text>{'Selected Document'}</Text>
                {isDocument == 1 && (
                  <Picker
                    style={[{ marginLeft: 20, paddingVertical: 6, paddingHorizontal: 12 }]}
                    selectedValue={documentId}
                    onValueChange={(value, key) => {
                      setDocumentId(value);
                      setSelectedDocument(Documents[key]);
                    }}
                  >
                    {Documents.length > 0 &&
                      Documents.map((document, index) => {
                        return (
                          <Picker.Item
                            style={styles.selectOption}
                            key={index}
                            label={document.document_name}
                            value={document.id}
                          />
                        );
                      })}
                  </Picker>
                )}
              </View>
            </View>
            {isDocument == 0 && (
              <>
                {Platform.OS == 'web' && (
                  <>
                    <Editor
                      value={StoreWavier}
                      onTextChange={(e) => setStoreWavier(e.htmlValue)}
                      style={{ height: 185, marginBottom: '10px' }}
                      modules={quillModules}
                      onKeyDown={(event) => {
                        event.stopPropagation();
                      }}
                    />
                  </>
                )}
              </>
            )}
            {isDocument == 1 && (
              <ScrollView style={{ height: 251, marginBottom: 10, borderWidth: 1, borderColor: '#ccc' }}>
                {selectedDocument && (
                  <>
                    {selectedDocument.document_type == 1 ? (
                      <>
                        {Platform.OS === 'web' && (
                          <embed
                            style={{ width: '100%' }}
                            src={API_URL + selectedDocument.document_file}
                            type="application/pdf"
                            width="300"
                            height="500"
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {Platform.OS === 'web' ? (
                          <div
                            style={{ padding: 8 }}
                            dangerouslySetInnerHTML={{ __html: selectedDocument.document_content }}
                          ></div>
                        ) : (
                          <WebView source={{ html: selectedDocument.document_content }} />
                        )}
                      </>
                    )}
                  </>
                )}
              </ScrollView>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]}>
              Agreement Text
            </Text>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {'Shown as checkbox label on the rental site. Can include links (e.g. /termsandconditions).'}
            </Text>
            {Platform.OS == 'web' && (
              <>
                <Editor
                  value={Disclaimer}
                  onTextChange={(e) => setDisclaimer(e.htmlValue)}
                  style={{ height: 125, marginBottom: '10px' }}
                  modules={quillModules}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              </>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel]}>Confirmation Email</Text>
            <View style={[styles.inputRow]}>
              <View style={[styles.inputContainer, { flex: 1 }]}>
                <BOHTlbCheckbox
                  style={{ marginLeft: 0 }}
                  label={'Enable Confirmation Email'}
                  CheckboxProps={{ value: !!isConfirmationEmailEnabled }}
                  onPress={() => setIsConfirmationEmailEnabled(+!isConfirmationEmailEnabled)}
                />
              </View>
            </View>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Email confirmation template: \nPlease use [customer_name], [store_name], [meeting_location], [rental_items_names], [start_date], [end_date], [start_time], [end_time]`}
            </Text>
            {Platform.OS == 'web' && (
              <>
                <Editor
                  value={EmailConfirmation}
                  onTextChange={(e) => setEmailConfirmation(e.htmlValue)}
                  style={{ height: 185, marginBottom: '10px' }}
                  modules={quillModules}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              </>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Text confirmation template: \nPlease use [customer_name], [store_name], [bodhi_protect], [order_number], [meeting_location], [rental_items_names], [start_date], [end_date], [start_time], [end_time]`}
            </Text>
            <TextInput
              style={[styles.input, styles.textarea, { height: 150, }]}
              placeholder="State"
              value={TextConfirmation}
              onChangeText={setTextConfirmation}
              placeholderTextColor="#ccc"
              multiline={true}
            />
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Abandoned confirmation template: \nPlease use [customer_name], [store_name], [order_number], [start_date], [end_date], [start_time], [end_time]`}
            </Text>
            {Platform.OS == 'web' && (
              <>
                <Editor
                  value={AEmailConfirmation}
                  onTextChange={(e) => setAEmailConfirmation(e.htmlValue)}
                  style={{ height: 185, marginBottom: '10px' }}
                  modules={quillModules}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              </>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Swap equipment confirmation template: \nPlease use [customer_name], [location], [lock_combo], [lock], [delivery_number], [combination], [color], [rack], [geo_lat], [geo_long]`}
            </Text>
            <TextInput
              style={[styles.input, styles.textarea, { height: 150, }]}
              placeholder="Hello [customer_name], your..."
              value={SwapEquipmentConfirmation}
              onChangeText={setSwapEquipmentConfirmation}
              placeholderTextColor="#ccc"
              multiline={true}
            />
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Document request email template: \nPlease use [customer_name], [store_name], [driver_type], [order_number], [upload_link], [upload_button], [meeting_location], [rental_items_names], [required_documents], [link_expires_at]`}
            </Text>
            {Platform.OS == 'web' && (
              <>
                <Editor
                  value={DocumentRequestEmail}
                  onTextChange={(e) => setDocumentRequestEmail(e.htmlValue)}
                  style={{ height: 185, marginBottom: '10px' }}
                  modules={quillModules}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              </>
            )}
          </View>

          <View style={styles.inputGroup}>
            <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]} selectable={true}>
              {`Document request text template: \nPlease use [customer_name], [store_name], [driver_type], [order_number], [upload_link], [meeting_location], [rental_items_names], [required_documents], [link_expires_at]`}
            </Text>
            <TextInput
              style={[styles.input, styles.textarea, { height: 150, }]}
              placeholder="Hi [customer_name], please submit your documents..."
              value={DocumentRequestText}
              onChangeText={setDocumentRequestText}
              placeholderTextColor="#ccc"
              multiline={true}
            />
          </View>

          <View style={{ alignItems: 'flex-end' }}>
            <TouchableOpacity onPress={SaveForm}>
              <Text style={[styles.addButton, { marginBottom: 0, marginTop: 16 }]}>{'Update'}</Text>
            </TouchableOpacity>
          </View>

        </View>

        {!!isRental && (
          <View style={cardStyle}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ fontSize: TextMediumLargeSize, fontWeight: 'bold' }}>Vehicle Rental Configuration</Text>
            </View>

            <View style={styles.inputGroup}>
              <Text style={[styles.label, styles.inputGroupLabel, { marginBottom: 8 }]}> 
                Document Requirements
              </Text>
              <View style={styles.toggleList}>
                <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="user-check" size={14} />
                    <Text style={styles.toggleLabel}>{'Questionnaire'}</Text>
                  </View>
                  <TouchableOpacity style={styles.togglePrimaryButton} onPress={() => setShowDriverScreeningInfo(true)}>
                    <Text style={{ color: '#fff', fontWeight: '600' }}>{'Manage'}</Text>
                  </TouchableOpacity>
                </View>

                {/* <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="user-check" size={14} />
                    <Text style={styles.toggleLabel}>{'Driver Screening'}</Text>
                  </View>
                  <View style={styles.toggleActions}>
                    <Switch
                      value={!!isDriverScreeningRequired}
                      onValueChange={() => setIsDriverScreeningRequired(+!isDriverScreeningRequired)}
                    />
                    <Pressable style={styles.toggleGhostButton} onPress={() => setShowDriverScreeningInfo(true)}>
                      <FontAwesome5 name="cog" size={24} />
                    </Pressable>
                  </View>
                </View> */}

                <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="id-card" size={14} />
                    <Text style={styles.toggleLabel}>{'License Upload'}</Text>
                  </View>
                  <Switch value={!!isLicenseRequired} onValueChange={() => setIsLicenseRequired(+!isLicenseRequired)} />
                </View>

                <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="shield-alt" size={14} />
                    <Text style={styles.toggleLabel}>{'Insurance Upload'}</Text>
                  </View>
                  <Switch value={!!isInsuranceRequired} onValueChange={() => setIsInsuranceRequired(+!isInsuranceRequired)} />
                </View>

                <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="file-signature" size={14} />
                    <Text style={styles.toggleLabel}>{'Agreement/Waiver Upload'}</Text>
                  </View>
                  <Switch value={!!isAgreementRequired} onValueChange={() => setIsAgreementRequired(+!isAgreementRequired)} />
                </View>

                <View style={styles.toggleRow}>
                  <View style={styles.toggleLabelWrap}>
                    <FontAwesome5 name="wine-glass" size={14} />
                    <Text style={styles.toggleLabel}>{'BAC Limit'}</Text>
                  </View>
                  <View style={{ width: 120 }}>
                    <NumericInput
                      placeholder="0.08"
                      value={bacLimit}
                      onChangeText={setBacLimit}
                      validMinNumber={0}
                      validMaxNumber={99.99}
                    />
                  </View>
                </View>
              </View>
            </View>

            <BrandContent brandId={brandId} fields={brandContentFields} />
          </View>
        )}
      </ScrollView>
      <DriverScreeningInfoModal
        isModalVisible={showDriverScreeningInfo}
        closeModal={() => setShowDriverScreeningInfo(false)}
        initialConfig={driverScreeningConfig}
        onSave={handleSaveDriverScreening}
      />
    </BasicLayout>
  );
};

const styles = StoreDetailsStyle;

export default StoreDetails;